
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import StringHelper from '@/helpers/StringHelper';
import ArrayHelper from '@/helpers/ArrayHelper';

export default Vue.extend({
  name: 'AlpineLayoutDefault',
  components: {
    AlpineNavBar: () => import('@/components/navbar/AlpineNavBar.vue'),
  },
  data() {
    return {
      alpineDefaultLayoutMainId: 'alpine-layout-default-main',
      productFruitsInitialized: false,
      initializingProductFruits: false
    };
  },
  computed: {
    isFullScreen(): boolean {
      return (
        this.$route
        && this.$route.meta
        && this.$route.meta.layout === 'fullscreen'
      );
    },
    getLevel(): Number {
      return this.$route.path.split('/').length - 1 || 1;
    },
    ...mapGetters('session', ['userId', 'getUserName']),
    ...mapGetters('oidc', ['oidcIsAuthenticated']),
  },
  watch: {
    $route() {
      // try/catch is just to be overly cautious
      try {
        const ele = document.getElementById(this.alpineDefaultLayoutMainId);
        if (ele) {
          ele.scrollTo(0, 0);
        }
        // Init on route change to ensure plugins have processed their initialization.
        this.initializePlugins();
      }
      catch { }
    },
    oidcIsAuthenticated(val)
    {
      if (val)
      {
        this.initializePlugins();
      }
    },
  },
  // ProductFruits added AL-34137 and enabled in all environments per AL-32585
  mounted() {
    this.initializePlugins();
  },
  methods: {
    initializePlugins()
    {
      // Short timeout to ensure oidc plugin has proper time to set the auth flags
      const that = this;
      setTimeout(() =>
      {
        that.initializeProductFruits();
      }, 500);
    },
    initializeProductFruits()
    {
      if (this.productFruitsInitialized || this.initializingProductFruits || !this.oidcIsAuthenticated)
      {
        return;
      }

      // just in case as we can have multiple calls on app load to this method per the defined watchers, route and oidc
      this.initializingProductFruits = true;

      try
      {
        // For local dev the tool tips can be an annoyance. Uncomment below to hide them but do not commit the changes.
        //const href: string = window.location.href;
        //if (!StringHelper.isNullOrEmpty(href) && href.toLowerCase().startsWith('http://localhost:5002'))
        //{
        //  this.productFruitsInitialized = true; // e.g. stop it from trying to init every route change
        //  this.initializingProductFruits = false;
        //  return;
        //}

        const userIdentifier = this.getUserName || this.userId; // username is preferred, if empty fallback to the id

        const productFruits = (window as any).$productFruits;
        if (!productFruits || !productFruits.push || StringHelper.isNullOrEmpty(userIdentifier))
        {
          return;
        }

        productFruits.push(['init', 'JgUSGw9uGjcbUdVY', 'en', { username: userIdentifier }]);
        this.productFruitsInitialized = true;
      }
      catch
      {
        // do nothing here.  we just don't want any error with fruits initializing to affect any page load in our application
      }
      finally
      {
        this.initializingProductFruits = false;
      }
    }
  },
});
